<template>
    <div class="co-rejeicao-documento">
        <div class="switch-rejeicao-documento">
            <v-switch
                v-model="value.rejeitarDocumento"
                name="rejeicao"
                class="ma-0 pa-0"
                color="primary"
                dense
                hide-details
            />
            <span class="checkbox-texto" @click="value.rejeitarDocumento = !value.rejeitarDocumento">
                Rejeição do documento
            </span>
        </div>

        <div class="hint-checkbox">
            {{ descricaoCampo }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'RejeicaoDocumento',
    props: {
        value: {
            required: true
        }
    },
    computed: {
        descricaoCampo() {
            return `Permite ao ${this.$tc("pt_br.signatario").toLowerCase()} rejeitar o documento`
        }
    }
}
</script>

<style lang="stylus">
.co-rejeicao-documento
    .switch-rejeicao-documento
        display flex
        align-items center
        cursor pointer

        .checkbox-texto
            font-size 14px
            display flex
            margin-left 10px
            color #777777
            text-align right
</style>